import MicroFrontend from '../Microfrontend'

export function ProductWeightsOverview() {
    const {REACT_APP_PRODUCT_WEIGHTS_OVERVIEW_HOST: productWeightsHost} = window.env

    return (
            <MicroFrontend
                host={productWeightsHost}
                microFrontendUiName="ProductWeightsOverview"/>
    )
}